module.exports = __webpack_public_path__ + "um.60872cdbbd21a3ba5b29.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/um.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/um.svg
// module chunks = styles